"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantApplicationResponse = void 0;
var ApplicantApplicationResponse = /** @class */ (function () {
    function ApplicantApplicationResponse() {
        this.applicationId = '';
        this.versionId = '';
        this.entrataApplicationId = 0;
        this.leaseId = 0;
        this.leaseIntervalId = 0;
        this.responseId = '';
    }
    return ApplicantApplicationResponse;
}());
exports.ApplicantApplicationResponse = ApplicantApplicationResponse;
